import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../utils/axiosInstance";
import { apiConfig } from "../../constants/apiConfig";
import { message } from "antd";

interface Props {
  email: string;
  password: string;
}

export const useLoginUser = (payload: Props) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const response = await axiosInstance.post(`${apiConfig.LOGIN}`, payload);
      return response.data;
    },
    onSuccess: async (data: any) => {
      localStorage.setItem("BETTY_ADMIN_USER_TOKEN", data?.data?.accessToken);

      await new Promise((resolve) => setTimeout(resolve, 100));
      if (data?.data?.role?.key !== "driver") {
        // message.info("others");
        navigate("/dashboard");
      } else {
        // message.info("driver");
        navigate("/driver/home");
      }
    },
    onError: (error: any) => {
      console.log("error?.response?. =>", error?.response);
      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage || "Login failed. Please try again.");
    },
  });
};
